function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
/**
  Returns true/false whether the argument provided to the function should be loaded using an internal XHR request. Valid data can either be a string URL or an Object with "url" and "headers" keys.
  @param dataItem The value to be tested
*/ export default function(dataItem) {
    return typeof dataItem === "string" || (typeof dataItem === "undefined" ? "undefined" : _type_of(dataItem)) === "object" && dataItem !== null && !!dataItem.url;
}

//# sourceMappingURL=isData.js.map